import React, { useEffect, useState } from 'react'
import { ChipSelect, Field, FoBtn, Pill } from './fieldUi'
import { fmtStamp, money2 } from '../FieldOpsKit'

/** Re-renders every `ms` so live timers ("12 min on site") keep moving. */
export const useNow = (ms) => {
    const [now, setNow] = useState(Date.now())
    useEffect(() => { const t = setInterval(() => setNow(Date.now()), ms || 30000); return () => clearInterval(t) }, [ms])
    return now
}

export const minutesLabel = (m) => (m < 60 ? m + ' min' : Math.floor(m / 60) + ' h ' + (m % 60 ? (m % 60) + ' min' : ''))

export const RETURN_TONE = { requested: 'amber', approved: 'blue', picked_up: 'blue', credited: 'green', rejected: 'red' }
export const RETURN_LABEL = { requested: 'Waiting for approval', approved: 'Approved', picked_up: 'Picked up', credited: 'Credited', rejected: 'Rejected' }

/** Lines of an order / invoice with quantities and totals. */
export const LinesTable = ({ lines, shortLines }) => {
    const shortBy = {}
    ;(shortLines || []).forEach((l) => { shortBy[l.sku] = l.qty })
    const total = lines.reduce((a, l) => a + (l.qty - (shortBy[l.sku] || 0)) * l.price, 0)
    return (
        <div className="fo-lines">
            {lines.map((l) => (
                <div key={l.sku} className="fo-lines__row">
                    <div><strong>{l.name}</strong><span>{l.sku} · {money2(l.price)} each{shortBy[l.sku] ? ' · ' + shortBy[l.sku] + ' not delivered' : ''}</span></div>
                    <div className="fo-lines__qty"><strong>{l.qty - (shortBy[l.sku] || 0)}</strong><span>{money2((l.qty - (shortBy[l.sku] || 0)) * l.price)}</span></div>
                </div>
            ))}
            <div className="fo-lines__total"><span>Total</span><strong>{money2(total)}</strong></div>
        </div>
    )
}

/** Returns requested from one visit / delivery, with their approval status. */
export const ReturnsMini = ({ ids, state }) => {
    const list = state.field.returns.filter((r) => (ids || []).indexOf(r.id) >= 0)
    if (list.length === 0) return null
    return (
        <div className="fo-stack" style={{ gap: 8 }}>
            {list.map((r) => (
                <div key={r.id} className="fo-retrow">
                    <div><strong>{r.no}</strong><span>{r.lines.map((l) => l.qty + '× ' + l.name).join(', ')}</span><small>{fmtStamp(r.at)}</small></div>
                    <div className="fo-retrow__r"><strong>{money2(r.total)}</strong><Pill tone={RETURN_TONE[r.status]}>{RETURN_LABEL[r.status]}</Pill>{r.pending ? <Pill tone="amber">To send</Pill> : null}</div>
                </div>
            ))}
        </div>
    )
}

/** Small photo placeholders (the real app opens the camera and uploads the file). */
export const PhotoStrip = ({ count }) => (count > 0 ? (
    <div className="fo-photos">{Array.from({ length: count }).map((_, i) => <div key={i} className="fo-photo"><span>Photo {i + 1}</span></div>)}</div>
) : null)

/** Reason picker used when a check-in happens far from the store or without location. */
export const FarForm = ({ title, reasons, onCancel, onConfirm }) => {
    const [r, setR] = useState('')
    const [tried, setTried] = useState(false)
    return (
        <React.Fragment>
            <Field label="Reason" error={tried && !r ? 'Pick a reason' : ''}><ChipSelect options={reasons} value={r} onChange={setR} /></Field>
            <div style={{ display: 'flex', gap: 10 }}><FoBtn kind="ghost" block onClick={onCancel}>Cancel</FoBtn><FoBtn kind="primary" block onClick={() => { setTried(true); if (r) onConfirm(r) }}>{title}</FoBtn></div>
        </React.Fragment>
    )
}

